// extracted by mini-css-extract-plugin
module.exports = {"title":"about-module--title--3QB7H","body":"about-module--body--xmZOA"};